<div class="dialog-content primary" [class.invited]="isInvited">
  <div class="dialog-header">
    <div class="header">
      Set your 4-digit PIN
    </div>

    <div class="description">
      You can change your PIN later in your profile.
    </div>
  </div>

  <div class="dialog-body">
    <div class="form-fields">
      <div class="description">
        C2 Keep uses a simple PIN system to quickly
        and securely log inventory transactions. Use a PIN you’ll remember easily.

        <img *ngIf="displayToggle" (click)="togglePIN()" [hidden]="hidePIN" class="password-icon"
             src="assets/icons/icon-field-hide-password.svg" alt="password-icon"/>
        <img *ngIf="displayToggle" (click)="togglePIN()" [hidden]="!hidePIN" class="password-icon shown"
             src="assets/icons/icon-field-show-password.svg" alt="password-icon"/>
      </div>

      <app-pin-input
        [inputsType]="inputsType"
        [focused]="true"
        [isLarge]="true"
        [invalid]="isInvalid"
        [disabled]="isDisabled"
        [validateSequence]="true"
        (pinValueComplete)="updatePin($event)"
        #pinInput
      ></app-pin-input>

      <div *ngIf="pinErrorMessage" class="error-message">{{pinErrorMessage}}</div>
    </div>

    <div class="controls">
      <app-button *ngIf="!isInvited"
                  customClasses="px-4"
                  [minWidth]="0"
                  class="prev-btn"
                  subStyle="transparent"
                  (clicked)="back()"
      >
        <img class="chevron-icon" src="assets/icons/icon-dropdown-chevron-right-gray.svg" alt="icon-chevron-left" />
        Back
      </app-button>

      <app-button customClasses="px-4 {{isInvited ? 'w-full' : ''}}"
                  [minWidth]="0"
                  class="continue-btn"
                  [class.invited]="isInvited"
                  text="Finish"
                  [disabled]="pinNumber.length < 4 || isDisabled || isInvalid"
                  (clicked)="setPin()"
                  #setPinButton
      >
      </app-button>
    </div>
  </div>
</div>
